import router from '@/routes/protectedRoute';
// import { getItem } from '@/utility/localStorageControl';

export default {
  loginBegin(state) {
    state.loading = true;
  },

  loginAssessmentSuccess(state, data) {
    state.loading = false;
    state.login = data;
    router.push('/assessment/pembinaan');
  },

  loginSuccessAssessmentFirst(state, data) {
    state.loading = false;
    state.data = data;
    router.push('/auth-assessment/first-login');
  },

  loginSuccessExpiredPassword(state, data) {
    state.loading = false;
    state.data = data;
    router.push('/auth-assessment/update-password');
  },

  resetPasswordSuccess(state, data) {
    state.loading = false;
    state.data = data;
    router.push('/auth-assessment/login');
  },

  loginErr(state, err) {
    state.loading = false;
    state.error = err;
  },

  logoutBegin(state) {
    state.loading = true;
  },

  logoutSuccess(state, data) {
    state.loading = false;
    state.login = data;
  },

  logoutErr(state, err) {
    state.loading = false;
    state.error = err;
  },

  showPrivacyPopup(state, status) {
    state.showPrivacyPopup = status;
  },

  setShowPrivacyPopup(state, status) {
    state.showPrivacyPopup = status;
  },

  checkPrivacyPolicySuccess(state) {
    state.agreePrivacy = true;
  },

  checkPrivacyPolicyErr(state, err) {
    state.error = err;
  },
};
